import { ApiPath } from "enums";
import { Get, Post, Put } from "utils";

export const createBankDepositApi = async (query) => {
  const res = await Post(`${ApiPath.BankDeposit}`, query);
  return res.data;
};

export const getBankDepositByIdApi = async (query) => {
  const res = await Get(`${ApiPath.BankDeposit}/${query?.id}`, query);
  return res.data;
};

export const updateBankDepositByIdApi = async (query) => {
  const res = await Put(`${ApiPath.BankDeposit}/${query?.id}`, query);
  return res.data;
};

export const getBankDepositListApi = async (query) => {
  const res = await Get(`${ApiPath.BankDeposit}/station/${query?.stationCode}`, query);
  return res.data;
};
